class AuthSyncService {
  private channel = new BroadcastChannel('auth-sync');

  constructor() {
    this.channel.onmessage = (event) => {
      if (event.data.type === 'TOKEN_REFRESHED') {
        this.onTokenRefreshed?.(event.data.tokens);
      }
    }
  }

  broadcastTokenRefresh(accessToken: string, refreshToken: string) {
    this.channel.postMessage({
      type: 'TOKEN_REFRESHED',
      tokens: { accessToken, refreshToken }
    })
  }

  onTokenRefreshed?: (token: { accessToken: string; refreshToken: string }) => void;
}

export const authSyncService = new AuthSyncService();
